export default function CTAAppel() {
  return (
    <>
      <section className="bg-[#143A66] py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-white text-2xl md:text-3xl font-extrabold mb-4">
            Moteur Somfy en panne à Strasbourg ?
          </h2>
          <p className="text-white/80 text-base leading-relaxed mb-8 max-w-2xl mx-auto">
            Nos techniciens remplacent et reprogramment vos moteurs Somfy rapidement. Devis gratuit, intervention sous 24h.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
            <a
              href="tel:0374473240"
              className="inline-flex items-center justify-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-lg font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
            <a
              href="#devis"
              className="inline-flex items-center justify-center gap-2 bg-white text-[#143A66] px-6 py-4 rounded-lg font-semibold text-base hover:bg-white/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
            >
              Devis gratuit
            </a>
          </div>
        </div>
      </section>

      <section className="bg-[#F4F8FB] py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-4">
            Besoin d'un remplacement de moteur Somfy dans le Bas-Rhin ?
          </h2>
          <p className="text-[#2F4A63] text-base leading-relaxed mb-8 max-w-2xl mx-auto">
            Contactez-nous dès maintenant pour un diagnostic gratuit et un devis personnalisé.
          </p>
          <a
            href="tel:0374473240"
            className="inline-flex items-center justify-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-lg font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
          >
            <i className="ri-phone-line text-lg"></i>
            Appeler le 03 74 47 32 40
          </a>
        </div>
      </section>
    </>
  );
}